import * as CONST from '../const';
class FormElementRenderer {
    owner;
    constructor(owner) {
        this.owner = owner;
    }
    getHiddenClass(option) {
        return option.hidden === true ? CONST.OPT_CLASS_HIDDEN : '';
    }
    checkIfOptionIsDigital(option) {
        return (CONST.DIGITAL_STEPS.indexOf(option.optionName) > -1);
    }
    checkIfOptionIsRolled(option) {
        return (CONST.ROLLED_STEPS.indexOf(option.optionName) > -1);
    }
    returnTooltipTrigger() {
        return `<a href="#" class="modal-tooltip tooltip_" title=""><svg class="t_icon" viewBox="0 0 92 92" width="100%" height="100%"><path d="M45.4 0C20 0.3-0.3 21.2 0 46.6c0.3 25.4 21.2 45.7 46.6 45.4 25.4-0.3 45.7-21.2 45.4-46.6C91.7 20 70.8-0.3 45.4 0zM45.3 74l-0.3 0c-3.9-0.1-6.7-3-6.6-6.9 0.1-3.8 2.9-6.5 6.7-6.5l0.2 0c4 0.1 6.7 3 6.6 6.9C51.9 71.3 49.1 74 45.3 74zM61.7 41.3c-0.9 1.3-2.9 2.9-5.5 4.9l-2.8 1.9c-1.5 1.2-2.5 2.3-2.8 3.4 -0.3 0.9-0.4 1.1-0.4 2.9l0 0.5H39.4l0-0.9c0.1-3.7 0.2-5.9 1.8-7.7 2.4-2.8 7.8-6.3 8-6.4 0.8-0.6 1.4-1.2 1.9-1.9 1.1-1.6 1.6-2.8 1.6-4 0-1.7-0.5-3.2-1.5-4.6 -0.9-1.3-2.7-2-5.3-2 -2.6 0-4.3 0.8-5.4 2.5 -1.1 1.7-1.6 3.5-1.6 5.4v0.5H27.9l0-0.5c0.3-6.8 2.7-11.6 7.2-14.5C37.9 18.9 41.4 18 45.5 18c5.3 0 9.9 1.3 13.4 3.9 3.6 2.6 5.4 6.5 5.4 11.6C64.4 36.3 63.5 38.9 61.7 41.3z"></path></svg></a>`;
    }
    bindTooltip(option) {
        const el = document.querySelector(`#option_${option.optionName} a.modal-tooltip`);
        if (el) {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.owner.renderTooltip(option.tooltip);
                return false;
            });
        }
    }
    appendListEl(el, cont, option) {
        cont.appendChild(el);
        const listEl = cont.querySelector(`#option_${option.optionName} > div > select`);
        if (listEl) {
            listEl.addEventListener('change', (e) => this.onListChange(e, option));
        }
    }
    appendFacesListEl(el, cont, option) {
        cont.appendChild(el);
        const listEl = cont.querySelector(`#option_${option.optionName} > div > select`);
        if (listEl) {
            listEl.addEventListener('change', (e) => this.onFacesListChange(e));
        }
    }
    appendCheckboxEl(el, cont, option) {
        cont.appendChild(el);
        const listEl = cont.querySelector(`#checkbox_${this.owner.getName()}_${option.optionName}`);
        if (listEl) {
            listEl.addEventListener('change', (e) => this.onCheckboxChange(e, option));
        }
    }
    getElementId(option) {
        return `${this.owner.getName()}_${option.optionName}`;
    }
    onListChange(e, option) {
        if (option.optionName) {
            if (e.target) {
                const el = e.target;
                this.owner.onListChange(option.optionName, parseInt(el.value));
            }
        }
    }
    onFacesListChange(e) {
        if (e.target) {
            const el = e.target;
            this.owner.onFacesListChange(parseInt(el.value));
        }
    }
    onCheckboxChange(e, option) {
        if (option.optionName) {
            if (e.target && !Array.isArray(option.variants)) {
                const el = e.target;
                const id = option.variants ? option.variants.id : option.id;
                this.owner.onCheckboxChange(option.optionName, id, el.checked);
            }
        }
    }
}
export default FormElementRenderer;
